import { render, staticRenderFns } from "./BulletinArticleComponent.vue?vue&type=template&id=8576d6dc&scoped=true&"
import script from "./BulletinArticleComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinArticleComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinArticleComponent.vue?vue&type=style&index=0&id=8576d6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8576d6dc",
  null
  
)

export default component.exports